import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const TONE_VARS = {
  success: { bg: 'var(--success-soft)', text: 'var(--success-strong)' },
  warning: { bg: 'var(--warning-soft)', text: 'var(--warning-strong)' },
  danger: { bg: 'var(--danger-soft)', text: 'var(--danger-strong)' },
  info: { bg: 'var(--info-soft)', text: 'var(--info-strong)' },
  neutral: { bg: 'var(--gray-100)', text: 'var(--text-secondary)' },
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 22,
    padding: '0 8px',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },
}));

/** Soft-bg / strong-text status pill. Replaces inline-hex Chips (docs/DESIGN_MAKEOVER.md 4.3). */
const StatusBadge = ({ tone = 'neutral', children, className = '' }) => {
  const classes = useStyles();
  const { bg, text } = TONE_VARS[tone] || TONE_VARS.neutral;
  return (
    <span
      className={`${classes.root} ${className}`}
      style={{ background: bg, color: text }}
    >
      {children}
    </span>
  );
};

export default StatusBadge;
